import script from "./Signup.vue?vue&type=script&setup=true&lang=js"
export * from "./Signup.vue?vue&type=script&setup=true&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=0912b6b8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0912b6b8"]])

export default __exports__